import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { beginnersArticle } from '@/mocks/articleData';

export default function BeginnersArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={beginnersArticle} />
      <Footer />
    </>
  );
}